// extracted by mini-css-extract-plugin
module.exports = {"container":"_2zFH2W mz-inline-label"};